import React, { useState } from 'react';

import MainHeader from '../../ui-components/MainHeader';
import TopHeaderUi from '../../ui-components/TopHeaderUi';

import CreateOrderModal from './CreateOrderModal';
import DefaultOrder from './DefaultOrder';
import DesignOrderModal from './DesignOrderModal';
import OldOrder from './OldOrder';
import PendingOrder from './PendingOrder';
import ColorOrderModal from './ColorOrderModal';
import FactoryPoOrder from './FactoryPoOrder';

// import { ca } from 'date-fns/locale';

const ComponentWrapper = () => {
	const [activeTab, setActiveTab] = useState('Default Order');
	const uiTabs = [
		'Default Order',
		'Pending Order',
		'Create Order',
		'Design Order',
		'Old Order',
		'Color Order',
		'Factory PO Order'
	];

	const renderComponents = () => {
		switch (activeTab) {
			case 'Default Order':
				return <DefaultOrder />;
			case 'Pending Order':
				return <PendingOrder />;
			case 'Create Order':
				return <CreateOrderModal />;
			case 'Design Order':
				return <DesignOrderModal />;
			case 'Old Order':
				return <OldOrder />;
			case 'Color Order':
				return <ColorOrderModal />;
			case 'Factory PO Order':
				return <FactoryPoOrder />;

			default:
				return null;
		}
	};

	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default ComponentWrapper;
